module.exports = __webpack_public_path__ + "static/media/a17.a6198ce0.pdf";